{
	"formatSupportBy": "Format support provided by",
	"lgplV21": "LGPL v2.1",
	"licensedUnder": "library, licensed under",
	"rawspeed": "Rawspeed",
	"supportedCameras": "Supported cameras",
	"supportedExtensions": "Supported extensions"
}
